import { FC } from 'react';
import { SharingCardMeta } from './sharing-card';

export const SearchSugHead: FC = () => {
  return <SharingCardMeta />;
};
